import React, { useContext, useEffect, useMemo, useState } from "react";
import ReactTable from "../../components/ReactTable/ReactTable.jsx";
import { config } from "../../config.js";
import { SidebarContext } from "../../context/SidebarContext";
import SectionMenuLeft from "../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import "./Queries.css"; //  for skeleton & polish styles
import { toast } from "react-toastify";
import { LuArrowLeft } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function Queries() {
  const navigate = useNavigate()
  const { isSidebar } = useContext(SidebarContext);
  const [Queries, setQueries] = useState([]);
  const [filteredQueries, setFilteredQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const role = localStorage.getItem("adminRole");
  const adminCity =
    role === "sub-admin" ? localStorage.getItem("adminCity") : null;

  const handleUpdate = (id, newStatus, key) => {
    setQueries((prev) =>
      prev.map((query) =>
        query.id === id ? { ...query, [key]: newStatus } : query,
      ),
    );
  };
  //  Fetch Queries
  const fetchQueries = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}queries${adminCity ? `?adc=${adminCity.toLocaleLowerCase()}` : ""}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
        },
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();
      if (result.status && Array.isArray(result.queries)) {
        setQueries(result.queries);
        setFilteredQueries(result.queries);
      } else {
        setQueries([]);
        setFilteredQueries([]);
      }
    } catch (error) {
      console.error("Fetching queries failed:", error);
      setQueries([]);
      setFilteredQueries([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQueries();
  }, []);

  const ToggleButtonStatus = ({ uid, initialStatus, onUpdate }) => {
    const [status, setStatus] = useState(initialStatus);

    const handleToggleStatus = async () => {
      //  decide next status locally
      const newStatus = status === "pending" ? "success" : "pending";

      //  1. update UI immediately
      setStatus(newStatus);
      if (onUpdate) onUpdate(uid, newStatus);

      try {
        const response = await fetch(
          `${config.backEndBaseUrl}queries/status/${uid}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
          },
        );

        if (!response.ok) throw new Error("Network response was not ok");

        //  optional: sync with backend response
        const result = await response.json();

        if (result?.newStatus && result.newStatus !== newStatus) {
          setStatus(result.newStatus);
          if (onUpdate) onUpdate(uid, result.newStatus);
        }
      } catch (error) {
        console.error("Error updating status:", error);

        //  rollback if API fails
        const rollbackStatus = status;
        setStatus(rollbackStatus);
        if (onUpdate) onUpdate(uid, rollbackStatus);
      }
    };

    return (
      <div className="toggle-container" onClick={handleToggleStatus}>
        <div
          className={`toggle-switch ${status === "success" ? "active" : ""}`}
        >
          <div className="toggle-knob"></div>
        </div>
        <span className={`toggle-text ${status === "success" ? "active" : ""}`}>
          {status === "success" ? "resolved" : "pending"}
        </span>
      </div>
    );
  };

  //  Table Columns
  const columns = useMemo(
    () => [
      {
        accessorKey: "driverName",
        header: "Driver",
      },
      {
        accessorKey: "createdAt",
        header: "Date",
        Cell: ({ cell }) => {
          const date = cell.getValue();

          if (!date) return "-";

          return (
            <div>
              <div style={{ fontWeight: 500 }}>
                {date.split(",")[0]} {/* 31 Mar 2026 */}
              </div>
              <div style={{ fontSize: "12px", color: "#6b7280" }}>
                {date.split(",")[1]} {/* 05:44 PM */}
              </div>
            </div>
          );
        },
      },
      {
        accessorKey: "message",
        header: "Query",
      },
      {
        accessorKey: "status",
        header: "status",
        Cell: ({ cell }) => (
          <ToggleButtonStatus
            uid={cell.row.original.id}
            initialStatus={cell.getValue()}
            onUpdate={(id, newStatus) => handleUpdate(id, newStatus, "status")}
          />
        ),
      },
    ],
    [],
  );

  //  Skeleton Loader
  const SkeletonLoader = () => (
    <div className="skeleton-wrapper">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="skeleton-row">
          <div className="skeleton-cell long"></div>
          <div className="skeleton-cell small"></div>
          <div className="skeleton-cell medium"></div>
          <div className="skeleton-cell medium"></div>
          <div className="skeleton-cell short"></div>
          <div className="skeleton-cell small"></div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />
            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
              >
                <div className="main-content-inner">
                  <div className="main-content-wrap">
                    <div className="tf-section">
                      <div className="wg-box" style={{ marginBottom: "20px" }}>
                        <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                          <div className="flex items-center gap-3">
                            <button
                              className="back-btn flex items-center gap-2"
                              onClick={() => navigate("/")}
                            >
                              <LuArrowLeft size={16} />
                              {/* <span>Back</span> */}
                            </button>
                            
                            <h5 className="fare-heading">Queries Overview</h5>
                          </div>
                        </div>

                        {/*  Show Skeleton or Table */}
                        {loading ? (
                          <SkeletonLoader />
                        ) : (
                          <ReactTable
                            columns={columns}
                            data={filteredQueries}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Queries;
